angular.module('unica_approvation_list.approvation_list_services')

.factory('ApprovationListListService', function ($http, $window, getBaseApiURL) {

	var approvationListListService = {};

	approvationListListService.list = function (invitationListId) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/list/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_lists;
			}

		});
	};

	approvationListListService.listZm = function (userId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/list-zm/' + userId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_lists;
			}

		});
	};


	approvationListListService.listAm = function (userId) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/list-am/' + userId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_lists;
			}

		});
	};

	approvationListListService.get = function (id) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/detail/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_list;
			}

		});
	};


	approvationListListService.exportList = function (id) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/approvation-list/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	return approvationListListService;
});